export default {
  methods: {
    stateUpload (arg) {
      let state = arg ? '' : this.$store.state
      this.$store.dispatch('uploadState', state)
        .then(response => {
          if (response) console.log('state upload status:', response.data.status)
        })
        .catch(err => {
          console.log(err)
        })
    },
    getState (token) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$store.dispatch('getStateFromServer', token)
          .then(response => {
            resolve(response)
          }).catch(err => {
            reject(err)
            console.log(err)
          })
      })
    },
    resetState () {
      this.stateUpload('clear')
    },
    updateState (state) {
      this.$store.commit('stateUpdate', state)
    }
  }
}
